<template>
  <div class="home rj-content">
    <h1>Hola</h1>
    <div class="banner"></div>
    <v-row>
      <v-col sm="12">
        <v-row>
          <img src="../assets/cover.png" alt="" width="100%">
        </v-row>
      </v-col>
      <v-col sm="12" md="4">
        <v-card link :to="'/usuarios'">
          <div class="ctn-img">
            <img src="../assets/contact-card.png" width="75px"/>
          </div>
          <v-card-title>
            <h3 class="title-card">Usuarios</h3>
          </v-card-title>
          <v-card-text>
            <p>Aquí podrás buscar, ver y editar la información personal de los usuarios registrados en el portal de
              Ruben Jungbluth.</p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col sm="12" md="4">
        <v-card link :to="'/consultas'">
          <div class="ctn-img">
            <img src="../assets/query.png" width="60px"/>
          </div>
          <v-card-title>
            <h3 class="title-card">Consultas personales</h3>
          </v-card-title>
          <v-card-text>
            <p>Aquí se encuentran agendadas las consultas personales solicitadas por los usuarios.</p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col sm="12" md="4">
        <v-card link :to="'/carta-astral'">
          <div class="ctn-img">
            <img src="../assets/carta-astral.png"/>
          </div>
          <v-card-title>
            <h3 class="title-card">Cartas astrales</h3>
          </v-card-title>
          <v-card-text>
            <p>Aquí podrás colocar y editar la carta astral respectiva a los usuarios que han solicitado una.</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: 'Hello',
  computed: {
    ...mapState('user', [
      'info',
    ]),
  },
  methods: {
    ...mapActions(['loaderChange']),
    ...mapActions(
        'user', [
          'fetchInfo',
        ]
    ),
  },
  mounted() {
    this.loaderChange(true)
    this.fetchInfo().finally(() => {
      this.loaderChange(false)
    })
  }
}
</script>
<style lang="scss" scoped>
::v-deep .title-card {
  color: #656565;
}

h3 {
  font-size: 16px;
}

.row {
  > div {
    display: flex;
  }
}

::v-deep .v-card {
  min-height: 340px;

  .ctn-img {
    width: 100%;
    height: 120px;
    padding-top: 40px;
    display: flex;
    align-items: center;
  }

  img {
    display: block;
    margin: 20px auto;
    max-width: 150px;
  }

  h3 {
    margin-top: 20px;
  }

  p {
    font-size: 12px;
  }
}
</style>
